const styles = {
  wrapperSx: {
    width: { xs: "100%", md: "75%" },
    background: "linear-gradient(135deg, #09090b 0%, #101010 100%)",
    borderRadius: { xs: 0, sm: "16px" },
    border: "1px solid rgba(255,255,255,0.07)",
    overflow: "hidden",
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    transition: "opacity 0.7s ease, transform 0.7s ease",
    position: "relative",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.1), 0 40px 80px rgba(0,0,0,0.6)",
  },

  contentSx: {
    flex: { xs: "unset", sm: "0 0 48%" },
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: { xs: 3, md: 4 },
    px: { xs: 3, sm: 4, md: 6 },
    py: { xs: 4, md: 5 },
    minHeight: { xs: "auto", sm: "400px", md: "440px" },
  },

  badgeSx: {
    display: "inline-flex",
    alignItems: "center",
    gap: 1,
    backgroundColor: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: "20px",
    px: 1.5,
    py: 0.6,
    alignSelf: "flex-start",
  },

  iconSx: {
    width: "15px",
    height: "15px",
    opacity: 0.75,
  },

  platformSx: {
    color: "rgba(255,255,255,0.55)",
    fontSize: "0.6rem",
    fontWeight: 700,
    letterSpacing: "0.22em",
    textTransform: "uppercase",
  },

  titleSx: {
    color: "white",
    fontWeight: 800,
    fontSize: { xs: "2rem", sm: "2rem", md: "2.6rem" },
    letterSpacing: "-0.04em",
    lineHeight: 1.05,
    mb: 1.5,
  },

  descSx: {
    color: "rgba(255,255,255,0.35)",
    fontSize: { xs: "0.82rem", md: "0.875rem" },
    lineHeight: 1.6,
    maxWidth: "280px",
  },

  ctaSx: {
    display: "inline-flex",
    alignItems: "center",
    gap: 1,
    textDecoration: "none",
    alignSelf: "flex-start",
    backgroundColor: "transparent",
    border: "1px solid rgba(255,255,255,0.45)",
    borderRadius: "8px",
    px: 2,
    py: 1.25,
    transition: "all 0.2s",
    "&:hover": {
      backgroundColor: "white",
      borderColor: "white",
      "& .cta-text, & .cta-arrow": { color: "black" },
    },
  },

  ctaTextSx: {
    color: "white",
    fontSize: "0.75rem",
    fontWeight: 600,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    whiteSpace: "nowrap",
    transition: "color 0.2s",
  },

  arrowSx: {
    color: "white",
    fontSize: "1rem",
    lineHeight: 1,
    flexShrink: 0,
    transition: "color 0.2s",
  },

  playerPanelSx: {
    display: "flex",
    flex: { xs: "unset", sm: 1 },
    height: { xs: "450px", sm: "auto" },
    position: "relative",
    alignItems: "stretch",
    p: { xs: 2, sm: 2 },
    pt: { xs: 0, sm: 2 },
    pl: { xs: 2, sm: 0 },
  },

  playerContainerSx: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    borderRadius: "12px",
    overflow: "hidden",
    border: "1px solid rgba(255,255,255,0.08)",
    backgroundColor: "#0a0a0a",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.05)",
  },

  playerHeaderSx: {
    display: "flex",
    alignItems: "center",
    gap: 1.5,
    px: 2,
    py: 1.25,
    borderBottom: "1px solid rgba(255,255,255,0.06)",
    backgroundColor: "rgba(255,255,255,0.02)",
    flexShrink: 0,
  },

  windowControlsSx: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    mr: 0.5,
    "&:hover .dot-icon": { opacity: 1 },
  },

  dotSx: {
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    flexShrink: 0,
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "default",
  },

  dotIconSx: {
    fontSize: "7px",
    fontWeight: 900,
    color: "rgba(0,0,0,0.5)",
    opacity: 0,
    transition: "opacity 0.15s",
    lineHeight: 1,
    userSelect: "none",
    pointerEvents: "none",
  },

  playerHeaderIconWrapSx: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    opacity: 0.85,
  },

  playerHeaderIconSx: {
    width: "13px",
    height: "13px",
  },

  playerHeaderTextSx: {
    color: "rgba(255,255,255,0.4)",
    fontSize: "0.6rem",
    fontWeight: 500,
    letterSpacing: "0.08em",
    whiteSpace: "nowrap",
  },

  iframeWrapSx: {
    flex: 1,
    position: "relative",
    minHeight: "360px",
    m: 2,
    borderRadius: "10px",
    overflow: "hidden",
    backgroundColor: "#fff",
    boxShadow: "0 0 0 1px rgba(255,255,255,0.12), 0 8px 64px rgba(0,0,0,0.95), 0 0 100px rgba(255,255,255,0.04)",
  },

  playBtnOverlaySx: {
    position: "absolute",
    left: 0,
    top: 0,
    width: "48px",
    height: "100%",
    backdropFilter: "saturate(0) brightness(4)",
    WebkitBackdropFilter: "saturate(0) brightness(4)",
    pointerEvents: "none",
    zIndex: 2,
  },

  playerFooterSx: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: "50px",
    backgroundColor: "#0d0d0d",
    borderTop: "1px solid rgba(255,255,255,0.06)",
    display: "flex",
    alignItems: "center",
    gap: 1.5,
    px: 2,
    pointerEvents: "none",
    zIndex: 2,
  },

  playerFooterAvatarSx: {
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    backgroundColor: "#000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    overflow: "hidden",
  },

  playerFooterIconSx: {
    width: "36px",
    height: "36px",
    objectFit: "cover",
  },

  playerFooterTextSx: {
    color: "rgba(0,0,0,0.25)",
    fontSize: "0.58rem",
    fontWeight: 600,
    letterSpacing: "0.1em",
    textTransform: "uppercase",
  },

  scFooterCoverSx: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: "56px",
    backgroundColor: "#fff",
    borderTop: "1px solid rgba(0,0,0,0.06)",
    display: "flex",
    alignItems: "center",
    gap: 1.5,
    px: 2,
    pointerEvents: "none",
    zIndex: 2,
  },

  iframeFadeSx: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: "56px",
    background: "linear-gradient(to top, #0d0d0d, transparent)",
    pointerEvents: "none",
    zIndex: 1,
  },
};

export default styles;
